import { render, staticRenderFns } from "./postalCode.vue?vue&type=template&id=88288410&scoped=true"
import script from "./postalCode.vue?vue&type=script&lang=js"
export * from "./postalCode.vue?vue&type=script&lang=js"
import style0 from "./postalCode.vue?vue&type=style&index=0&id=88288410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88288410",
  null
  
)

export default component.exports